import React, { useEffect, useState } from 'react';

import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';

import useMediaQuery from '@mui/material/useMediaQuery';
import DeviceRotate from 'src/component/UI/DeviceRotate';
import variables from 'src/style/variable/variables.module.scss';
import Button from 'src/component/UI/Button';
import DataTable from 'src/component/UI/DataTable';
import { formatDate } from 'src/utils/utils';
import { List } from 'immutable';
import { getTablePagePreferences } from 'src/module/authentication/selector';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDeviceCheckSheets } from 'src/module/device/action';
import { getAlarmCheckSheetReports, getDeviceCheckSheetLoading, getDeviceCheckSheetTotal, getDeviceCheckSheetTotalPages } from 'src/module/device/selector';
import { closeCheckSheet, fetchCheckSheetTasks, openCheckSheet } from 'src/module/checkSheet/action';
import { getCheckSheetReportIsOpen } from 'src/module/checkSheet/selector';
import PermissionFence from 'src/component/PermissionFence';
import InsulationInspectionTestReport from './InsulationInspectionTestReport';
import CancelIcon from '@mui/icons-material/CancelSharp';
import CheckCircleIcon from '@mui/icons-material/CheckCircleSharp';
import { useTranslation } from 'src/i18n';

export default function InsulationInspectionTestReportContent (props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    deviceId,
  } = props;
  const checkSheetType = 'insulation-inspection';
  const [collapsed, setCollapsed] = useState(true);
  const [selected, setSelected] = useState(null);
  const showModal = useSelector(getCheckSheetReportIsOpen(checkSheetType));
  const totalPages = useSelector(getDeviceCheckSheetTotalPages(deviceId, checkSheetType));
  const total = useSelector(getDeviceCheckSheetTotal(deviceId, checkSheetType));
  const loading = useSelector(getDeviceCheckSheetLoading(deviceId, checkSheetType));

  const isMobile = useMediaQuery(`(max-width: ${variables.mobileWidth})`);
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const [showRotateMessage, setShowRotateMessage] = useState(isMobile && isPortrait);
  useEffect(() => {
    setShowRotateMessage(isMobile && isPortrait);
  }, [isMobile, isPortrait]);
  useEffect(() => {
    dispatch(closeCheckSheet(checkSheetType));

  }, [deviceId]);
  function formatName (data) {
    return data.get('first_name') + " " + data.get('last_name');
  }

  const columns: any = [
    {
      id: 'notes',
      Header: t('alarms.notes'),
      accessor: (row) => row.get('notes'),
      Cell: (row: any) => row.cell.value,
    },
    {
      id: 'created_by',
      Header: t('testingReports.createdBy'),
      accessor: (row) => row.get('created_by'),
      Cell: (row: any) => formatName(row.cell.row.original)
    },
    {
      id: 'created_at',
      Header: t('testingReports.createdAt'),
      accessor: (row) => row.get('created_at'),
      Cell: (row: any) => (row.cell.value ? (<>{formatDate(row.cell.value)}</>) : ''),
    },
    {
      id: 'passed',
      Header: t('common.passFail'),
      accessor: (row) => row.get('passed'),
      Cell: (row: any) => <>{row.cell.value?
        <CheckCircleIcon style={{ color: variables.success, fontSize: 24, marginLeft: 20 }} />
        :
        <CancelIcon style={{ color: variables.error, fontSize: 24, marginLeft: 20 }} />
      }</>,
    }
  ];
  const userPagePreference = useSelector(getTablePagePreferences('device-testing-report-table'));
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(userPagePreference);
  const [sort, setSort] = useState(null);
  const fetchPage = (_page, _pageSize, _filter, _sort) => {
    setPage(_page);
    setPageSize(_pageSize);
    setSort(_sort);
  };
  useEffect(() => {
    if (deviceId && !collapsed && !showRotateMessage) {
      const paginationDetails = {
        page,
        pageSize,
        sort
      };
      dispatch(fetchDeviceCheckSheets(checkSheetType, deviceId, paginationDetails));
      dispatch(fetchCheckSheetTasks('insulation-inspection-general'));
    }
  }, [deviceId, page, pageSize, sort, collapsed, showRotateMessage]);
  const reports = useSelector(getAlarmCheckSheetReports(deviceId, checkSheetType));
  const onRowClick = (row) => {
    if (!row.original.get('file_id')) {
      setSelected(row.original.get('id'));
      dispatch(openCheckSheet(checkSheetType));
    }
  };
  const onClickCreate = () => {
    dispatch(openCheckSheet(checkSheetType));
    setSelected(null);
  };

  return (
    <div id="testing-reports-content"  className='testing-reports-content' data-testid='testing-reports-content'>
      <Paper>
        <h3 className='expandable' onClick={() => setCollapsed(!collapsed)}>{t('insulationInspection.title')} &nbsp;<span className='expand-arrow'>{collapsed ?  '▼': '▲' }</span></h3>

        {!collapsed ?
          <div className="content-wrapper">
            <div className='create-button'>
              <PermissionFence can='edit-device'>
                <Button className='create-report-button' cta onClick={onClickCreate}>{t('insulationInspection.createReport')}</Button>
              </PermissionFence>
            </div>
            <InsulationInspectionTestReport open={showModal} reportId={selected} deviceId={deviceId} handleClose={() => dispatch(closeCheckSheet(checkSheetType))} />
            {collapsed && showRotateMessage ?
              <DeviceRotate />
              : <DataTable
                filterable={false}
                filterLabel='Search Alarms'
                pagination={true}
                numPages={totalPages}
                totalRecords={total}
                loading={loading}
                data={List(reports)}
                columns={columns}
                fetchPage={fetchPage}
                handleCellClick={onRowClick}
                columnWidths = {['33%', '33%', '23%']}
                placeholder={<><span>{t('testingReports.noReports')} </span><span role='img' aria-label='Sweat Smile'>😅</span></>}
                tableId={'device-testing-report-table'}
              />}
          </div>
          : null}


      </Paper>
    </div>
  );
}

InsulationInspectionTestReportContent.propTypes = {
  deviceId: PropTypes.string,
};

InsulationInspectionTestReportContent.defaultProps = {
  deviceId: null,
};
